var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crumb-tit',[_c('span',{attrs:{"slot":"breadTit"},slot:"breadTit"},[_vm._v(_vm._s(_vm.crumbLabel))]),_c('span',{attrs:{"slot":"secondTit"},slot:"secondTit"},[_vm._v(_vm._s(_vm.crumbLabel))])]),_c('div',{staticClass:"main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }